<div class="modal fade" :id="modalComponentId" tabindex="-1" role="dialog" :aria-labelledby="modalComponentId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalComponentId + 'Label'">{{modalHeading}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalCloseClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="alert alert-info fade show" role="alert" >
                    Please note that products linked to the combo discount group will have the discount amount applied when they are included in an order where all linked products are ordered together.
                </div>
                <div class="alert alert-success alert-dismissible fade show" role="alert" v-if="showSuccessMessage">
                    {{successMessage}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="showErrorMessage">
                    {{errorMessage}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="clearMessageAlerts">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="input-group pb-4">
                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="productSearchQuery">
                    <div class="input-group-append">
                        <span class="input-group-text" id="basic-addon1">
                            <i class="fas fa-search"></i>
                        </span>
                    </div>
                </div>
                <button class="btn btn-primary float-right" @click="onFilterSearchClick">Search</button>
                
                <div class="table-responsive pt-4" v-if="!showSuccessMessage && !showErrorMessage && !loading">
                    <table class="table table-hover mb-0">
                        <thead>
                            <tr>
                                <th>Select</th>
                                <th>#</th>
                                <th>Name</th>
                                <th>Apply Discount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(product, index) in comboDiscountGroupProducts" :key="index">
                               <td>
                                    <input type="checkbox" v-model="product.isSelected" @change="onProductSelectOrUnselect(product)">
                               </td>
                               <td>{{product.productId}}</td>
                               <td>{{product.name}}</td>
                               <td>
                                    <input type="checkbox" v-model="product.applyDiscount" :disabled="!product.isSelected" @change="onApplyDiscountChanged(product)">
                               </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" @click="onModalSaveClick(true)" :disabled="loading" v-if="!showSuccessMessage && !showErrorMessage">SAVE</button>
                <button type="button" class="btn btn-secondary" :disabled="loading" data-dismiss="modal" @click="onModalCloseClick" v-if="!showSuccessMessage && !showErrorMessage">CLOSE</button>
                <button type="button" class="btn btn-primary" :disabled="loading" v-if="showSuccessMessage || showErrorMessage" @click="clearMessageAlerts">OK</button>
            </div>
        </div>
    </div>
</div>